// extracted by mini-css-extract-plugin
export var emailBlockLink = "_o3-0";